var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mpx-special-text"},[_vm._t("before"),_vm._l(((_vm.textArr)),function(item,index){return _c('div',{key:item.index,staticClass:"special-text-item",style:(_vm._f("transRpxStyle")([((_vm.verticalAlign)+(item.style))])),attrs:{"data-index":(index)}},[_vm._v(_vm._s(item.text))])}),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }